export default __webpack_public_path__ + "static/media/az-logo-pc.28159eea.svg";